import { Container } from 'src/components/common/Container'
import styled, { css } from 'styled-components'
import { Typography } from 'src/components/common/Typography'
import { Noto_body3_r12, Noto_subheading_b18 } from 'src/styles/fonts/NotoSansKrFonts'
import { CustomSwiper } from 'src/components/common/CustomSwiper'
import React, { useRef } from 'react'
import { Roboto_num2_b16 } from 'src/styles/fonts/RobotoFonts'
import { ellip } from 'src/styles/mixin'
import LazyImage from 'src/components/common/LazyImage'
import usePageNav from 'src/hooks/usePageNav.hook'
import RenderIf from 'src/components/common/RenderIf'
import Skeleton from 'react-loading-skeleton'
import { GiftReceiveResultPageProps } from 'src/pages/GiftCardPage/GiftReceiveResultPage'
import { getBrandAndCouponName } from 'src/utils'
import { Icon } from 'src/assets/svg/Icon'

const GiftResultHotDeal = ({ hotDealCouponList }: GiftReceiveResultPageProps) => {
  const { giftHotDealPageNav, giftHotDealDetailPageNav } = usePageNav()
  const containerRef = useRef<HTMLDivElement>(null)

  return (
    <S.GiftResultHotDealContainer ref={containerRef}>
      <S.GiftResultHotDealContents $option="flex_column">
        <S.GiftResultHotDealTitle $fontStyle={Noto_subheading_b18}>
          🔥 한정 수량 핫딜! 지금 바로 확인!🔥
        </S.GiftResultHotDealTitle>
        <CustomSwiper.Wrap type="default" $wrapstyle={S.HotDealListSwiperStyle}>
          {hotDealCouponList?.map(
            (
              { CouponName, BrandName, DiscountRate, SalePrice, CouponImage, CouponIdx },
              p_i: number,
            ) => (
              <CustomSwiper.Item
                key={p_i + 1}
                $itemstyle={S.HotDealListItem.SwiperItemStyle()}
                onClick={() => giftHotDealDetailPageNav(CouponIdx)}
              >
                <LazyImage src={CouponImage} alt="쿠폰" style={S.HotDealListItem.CouponImage} />
                <RenderIf when={!!SalePrice}>
                  <Container $option="flex_column">
                    <S.HotDealListItem.DiscountRate
                      $fontStyle={Roboto_num2_b16}
                      $color="var(--brand-50)"
                    >
                      {Math.floor((DiscountRate as number) * 10) / 10}%
                    </S.HotDealListItem.DiscountRate>
                    <S.HotDealListItem.SalePrice $fontStyle={Roboto_num2_b16}>
                      {SalePrice?.toLocaleString()}원
                    </S.HotDealListItem.SalePrice>
                  </Container>
                  <S.HotDealListItem.CouponName
                    $fontStyle={Noto_body3_r12}
                    $color="var(--black-90)"
                  >
                    [{BrandName}]
                    <br />
                    {getBrandAndCouponName(CouponName).couponName}
                  </S.HotDealListItem.CouponName>
                </RenderIf>
                <RenderIf when={!SalePrice}>
                  <Skeleton count={2} style={{ marginBottom: '5px' }} />
                </RenderIf>
              </CustomSwiper.Item>
            ),
          )}
          <CustomSwiper.Item
            key={0}
            $itemstyle={S.HotDealListItem.SwiperItemStyle()}
            onClick={giftHotDealPageNav}
          >
            <S.HotDealListItem.MoreBtn $option="flex_column" $style={S.HotDealListItem.CouponImage}>
              <Icon.PlusCircle />
              <Typography $fontStyle={Noto_body3_r12} $color="var(--black-50)">
                더보기
              </Typography>
            </S.HotDealListItem.MoreBtn>
          </CustomSwiper.Item>
        </CustomSwiper.Wrap>
      </S.GiftResultHotDealContents>
    </S.GiftResultHotDealContainer>
  )
}
export default GiftResultHotDeal

const S = {
  GiftResultHotDealContainer: styled(Container)`
    background: var(--white);
    padding: 30px 0 30px;
  `,
  GiftResultHotDealTitle: styled(Typography)`
    margin-left: 20px;
  `,
  GiftResultHotDealContents: styled(Container)``,
  HotDealListSwiperStyle: css`
    display: flex;
    flex-direction: row;
    gap: 10px;
    width: 100%;
    padding: 14px 10px 0 20px;
  `,
  HotDealListItem: {
    SwiperItemStyle: () => css`
      display: flex;
      flex-direction: column;
      width: 120px;
      margin-right: 10px;
    `,
    CouponImage: css`
      padding: 10px;
      width: 120px;
      height: 120px;
      border-radius: 12px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      margin-bottom: 6px;
      > img {
        border-radius: inherit;
      }
      &:hover {
        transform: scale(1.05);
      }
    `,
    DiscountRate: styled(Typography)``,
    SalePrice: styled(Typography)`
      margin-bottom: 6px;
    `,
    CouponName: styled(Typography)`
      ${ellip('line2')};
      word-break: keep-all;
    `,
    MoreBtn: styled(Container)`
      justify-content: center;
      align-items: center;
    `,
  },
}
